import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
    TranslateModule,
    MissingTranslationHandler,
    TranslateLoader,
    TranslateDefaultParser,
    MissingTranslationHandlerParams
} from '@ngx-translate/core';
import { Observable, map } from 'rxjs';

// When the value is missing in the json-file, use the key
export class PlacesMissingTranslationHandler implements MissingTranslationHandler {
    private static _parser = new TranslateDefaultParser();

    handle(params: MissingTranslationHandlerParams) {
        return PlacesMissingTranslationHandler._parser.interpolate(params.key, params.interpolateParams);
    }
}

// When a value is empty in the json-file = missing a translation value.
@Injectable()
export class CustomTranslateHttpLoader implements TranslateLoader {
    private http = inject(HttpClient);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getTranslation(lang: string): Observable<any> {
        return this.http.get(`/assets/i18n/${lang}.json`).pipe(
            map((resp) => this.keyAsTranslation(resp))
        );
    }

    private keyAsTranslation(obj) {
        for (const key of Object.keys(obj)) {
            if (typeof obj[key] === 'object') {
                obj[key] = this.keyAsTranslation(obj[key]);
            } else {
                obj[key] = obj[key] || (key + ' **'); // when a translation is empty, the key is used here
            }
        }
        return obj;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TranslateModuleForRoot = TranslateModule.forRoot({
    missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: PlacesMissingTranslationHandler
    },
    loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateHttpLoader
    },
    useDefaultLang: false
});
